import React, { useState } from "react";
import ModalMedTabs from "./modal/ModalMedTabs.js";
import { AuthProvider, useAuth } from "./login/authProvider.js";
import LoginButton from "./login/login.js";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';



function AppContent() {
  const { user } = useAuth();

  return <div>{user ? <ModalMedTabs /> : <LoginButton />}</div>;
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
      <ToastContainer position="top-center" autoClose={8000} />
    </AuthProvider>
  );
}

export default App;
